import { isDev, isUAT, isLocal, getApiEnv } from "../../../../config/env";
import styled from "@emotion/styled";
import { capitalize } from "lodash-es";
import React, { useState } from "react";

export const VersionLabel: React.FC = () => {
  const [isPartiallyVisible, setIsPartiallyVisible] = useState(false);

  if (isDev || isUAT || isLocal) {
    return (
      <VersionLabelContainer
        onClick={() => setIsPartiallyVisible(s => !s)}
        isPartiallyVisible={isPartiallyVisible}
      >
        {capitalize(getApiEnv())} API | v.{APP_VERSION}
      </VersionLabelContainer>
    );
  }
  return null;
};

// Sub components

const VersionLabelContainer = styled.div<{ isPartiallyVisible: boolean }>`
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 999;
  background-color: ${props => (props.isPartiallyVisible ? "transparent" : "red")};
  color: ${props => (props.isPartiallyVisible ? "transparent" : "white")};
  padding: 0.5rem;
  cursor: pointer;
  border: 1px ${props => (props.isPartiallyVisible ? "none" : "solid")} red;
`;
